import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const CERTIFICATION_ENDPOINTS = {
  base: `${BASE_URL}api/certifications/`,
  types: `${BASE_URL}api/certifications/types/`,
  export: `${BASE_URL}api/certifications/export/`,
  available: `${BASE_URL}api/certifications/available/`,
  all: `${BASE_URL}api/certifications/all/`,
  cert: (code) => `${BASE_URL}api/certifications/${code}/`,
  check: (code) => `${BASE_URL}api/certifications/check/${code}/`,
};

class Certification {
  async createCert(payload){
    return await request({
      url: CERTIFICATION_ENDPOINTS.base,
      method: "POST",
      body: payload,
    });
  }

  async getAvailableCodes(){
    return await request({
      url: CERTIFICATION_ENDPOINTS.available,
    });
  }

  async updateCert(code, payload){
    return await request({
      url: CERTIFICATION_ENDPOINTS.cert(code),
      method: "PATCH",
      body: payload,
    });
  }

  async deleteCert(code){
    return await request({
      url: CERTIFICATION_ENDPOINTS.cert(code),
      method: "DELETE",
    });
  }

  async checkCode(code){
    return await request({
      url: CERTIFICATION_ENDPOINTS.check(code),
    })
  }

  async getTypes(existing = false){
    const {data} = await request({
      url: CERTIFICATION_ENDPOINTS.types,
      query: {existing},
    });
    return data
  }

}

export const CertService = new Certification();
